import { VpSelect } from '../ui/VpSelect';

export interface WarehouseSelectorProps {
  warehouses: Array<{ id: number; code: string; name: string; is_default: boolean }>;
  currentId: number | null;
  onChange: (warehouseId: number) => void;
}

/**
 * Header warehouse selector. Logic unchanged (fires onChange with the chosen
 * warehouse_id); rendered with the shared react-select wrapper (Velzon).
 */
export function WarehouseSelector({ warehouses, currentId, onChange }: WarehouseSelectorProps) {
  if (warehouses.length === 0) return null;
  const options = warehouses.map((w) => ({
    value: w.id,
    label: `${w.name} (${w.code})${w.is_default ? ' ★' : ''}`,
  }));
  return (
    <VpSelect
      ariaLabel="Magazzino"
      options={options}
      value={currentId}
      onChange={(v) => onChange(Number(v))}
      width={240}
    />
  );
}
